import { render, staticRenderFns } from "./enterThePS2.vue?vue&type=template&id=1db08b8c&scoped=true&"
import script from "./enterThePS2.vue?vue&type=script&lang=js&"
export * from "./enterThePS2.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=1db08b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db08b8c",
  null
  
)

export default component.exports